import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ElxCombobox, ElxDropdown, ElxTagPicker, TagContainerOrientation, } from "@elixir/components";
import { useState } from "react";
import { GetAsCustomerFilterDropdownOption, GetPartnerAsFilterDropdownOption, } from "../../library/utilities/GetDropdownOption";
import { useLocaleStrings } from "../../library/providers/strings";
import { PrimaryButton, } from "@fluentui/react";
import "./SearchTags.css";
import { SearchType } from "../../models";
const SearchTags = ({ onSearch, countriesOptions, searchType, }) => {
    const [tagsInfo, setTagsInfo] = useState();
    const [resultTagsInfo, setResultTagsInfo] = useState();
    const [selectedCriteria, setSelectedCriteria] = useState("");
    const [selectedCriteriaKey, setSelectedCriteriaKey] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const selectionSearchoptions = searchType === SearchType.Customer
        ? GetAsCustomerFilterDropdownOption()
        : GetPartnerAsFilterDropdownOption();
    const addTag = (tag) => {
        if (selectedCriteria != "") {
            setErrorMessage("");
            const newTag = `${selectedCriteria}${tag.text}`;
            const newTagInfo = { key: selectedCriteria, text: newTag };
            if (tagsInfo && tagsInfo.length > 0) {
                const tags = tagsInfo === null || tagsInfo === void 0 ? void 0 : tagsInfo.filter((t) => t.key !== newTagInfo.key);
                tags.push(newTagInfo);
                setTagsInfo(tags);
            }
            else {
                setTagsInfo([newTagInfo]);
            }
            const newTagResultInfo = {
                key: selectedCriteriaKey,
                text: tag.text,
            };
            if (resultTagsInfo && resultTagsInfo.length > 0) {
                const tags = resultTagsInfo.filter((t) => t.key !== newTagResultInfo.key);
                tags.push(newTagResultInfo);
                setResultTagsInfo(tags);
            }
            else {
                setResultTagsInfo([newTagResultInfo]);
            }
        }
        else {
            setErrorMessage("Please select a Field");
        }
    };
    const removeTag = (tag) => {
        const newTags = tagsInfo === null || tagsInfo === void 0 ? void 0 : tagsInfo.filter((t) => t.key !== tag.key);
        if (newTags) {
            setTagsInfo(newTags);
            let key = "";
            selectionSearchoptions.some((option) => {
                if (tag.key.includes(option.text.toString())) {
                    key = option.key.toString();
                    return;
                }
            });
            if (key) {
                setResultTagsInfo(resultTagsInfo === null || resultTagsInfo === void 0 ? void 0 : resultTagsInfo.filter((x) => x.key !== key));
            }
        }
    };
    const { getLocalSpecificString } = useLocaleStrings();
    const setSearchCriteria = (_event, option) => {
        if (option) {
            setErrorMessage("");
            setSelectedCriteria(option === null || option === void 0 ? void 0 : option.text);
            setSelectedCriteriaKey((option === null || option === void 0 ? void 0 : option.key.toString()) || "");
        }
    };
    const setCountry = (_event, option) => {
        if (option) {
            addTag({ key: "CountryName", text: option.text });
        }
    };
    const triggerSearch = () => {
        onSearch(resultTagsInfo || []);
    };
    return (_jsxs("div", Object.assign({ className: "searchPanelAndTag" }, { children: [_jsx(ElxDropdown, { style: { width: 200 }, placeholder: getLocalSpecificString("searchFilterPH"), options: selectionSearchoptions, required: true, onChange: setSearchCriteria, errorMessage: errorMessage != "" ? errorMessage : undefined }), selectedCriteriaKey == "CountryName" && (_jsx("div", { children: _jsx(ElxCombobox, { style: { width: 200, paddingLeft: 5 }, placeholder: "Choose Country", options: countriesOptions || [], required: false, onChange: setCountry }) })), _jsx(ElxTagPicker, { style: { width: 300 }, placeholder: `Enter ${selectedCriteria}`, items: tagsInfo, orientation: TagContainerOrientation.Horizontal, disabled: selectedCriteriaKey == "CountryName", onAddTag: addTag, onRemoveTag: removeTag, styles: { root: { paddingLeft: 5 } } }), _jsx("div", Object.assign({ className: "searchStyle" }, { children: _jsx(PrimaryButton, { text: "Search", onClick: triggerSearch, allowDisabledFocus: true }) }))] })));
};
export default SearchTags;
